import { API_URL } from "../config/connect";

async function postCompanyData(endpoint, data) {
    const url = `${API_URL}/api/v1/user/profile/company/${endpoint}`;

    try {
        const accessToken = localStorage.getItem("access_token");

        if (!accessToken) {
            throw new Error("Access token is missing");
        }

        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });

        if (!response.ok) {
            throw new Error(`Error updating ${endpoint}: ${response.statusText}`);
        }

        const result = await response.json();
        return result;
    } catch (error) {
        console.error(`Failed to update ${endpoint}:`, error);
        throw error;
    }
}

export const updateRepresentative = (data) => postCompanyData("representative", data);
export const updateAbout = (data) => postCompanyData("about", data);
export const updateContacts = (data) => postCompanyData("contacts", data);
export const updateDecor = (data) => postCompanyData("decor", data);